import React from 'react';
import Routes from './routes';
// import { GlobalStyle } from './style';

function App() {
  return (
    <>
      {/* <GlobalStyle /> */}
      <Routes />
    </>
  );
}

export default App;
